import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './layouts/Layout';
import { AppProvider } from './context/AppContext';
import { SuspenseFallback } from './shared/components/SuspenseFallback';

const Home = lazy(() => import('./features/comercios/pages/Home').then((m) => ({ default: m.Home })));

const App = () => {
  const routed = (
    <Suspense fallback={<SuspenseFallback />}>
      <Home />
    </Suspense>
  );
  return (
    <AppProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={routed} />
            <Route path="*" element={routed} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
};

export default App;
